import Vue from "vue";
import { config } from "@/config";

Vue.prototype.$config = config;
